export default __webpack_public_path__ + "assets/images/864ad00ffc37a241454caa8d5b2389cf.svg";